<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >

        <el-form-item
                label="收款人"
                prop="accounts_legal"
        >
          <el-input
                  v-model="searchForm.accounts_legal"
                  placeholder="收款人"
                  style="width: 100px;"
          />
        </el-form-item>
        <el-form-item
                label="转账人"
                prop="drawname"
        >
          <el-input
                  v-model="searchForm.drawname"
                  placeholder="转账人"
                  style="width: 100px;"
          />
        </el-form-item>
        <el-form-item>
        <el-select
                class="filter-item"
                v-model="searchForm.state"
                placeholder="审核是否通过"
                width="50"
        >
          <el-option
                  v-for="item in settleOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
          ></el-option>
        </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
                  v-model="dateRange"
                  :picker-options="pickerOptions"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"    width="150">

          </el-date-picker>

        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </template>

    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
              label="收款商家/业务员"
      >
        <template slot-scope="scope">
          {{scope.row.transfer_agentname}}
        </template>
      </el-table-column>
      <el-table-column
        label="收款人"
      >
        <template slot-scope="scope">
          {{scope.row.accounts_legal}}
        </template>
      </el-table-column>
      <el-table-column
              label="转账人"
      >
        <template slot-scope="scope">
          {{scope.row.drawname}}
        </template>
      </el-table-column>
      <el-table-column
              label="转账时间"
      >
        <template slot-scope="scope">
          {{scope.row.pay_time2}}
        </template>
      </el-table-column>
      <el-table-column
              label="转账金额"
      >
        <template slot-scope="scope">
          {{scope.row.verifyamt2}}
        </template>
      </el-table-column>

      <el-table-column
              label="审核时间"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.state=='0' || scope.row.state=='1' ">
          {{scope.row.applytime2}}
          </div>
        </template>
      </el-table-column>

      <el-table-column
              label="备注"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.state=='0' || scope.row.state=='1' ">
            {{scope.row.return_msg}}
          </div>
        </template>
      </el-table-column>

      <el-table-column
              label="状态"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.state=='3'">
            未审核
          </div>
          <div v-else-if="scope.row.state=='0'">
            审核通过
          </div>
          <div v-else-if="scope.row.state=='1'">
            审核不通过
          </div>
        </template>
      </el-table-column>

      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="220"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.state=='3'">
          <el-button
                  type="primary"
                  plain
                  size="mini"
                  v-if="(is_dl_type=='-1' || is_agentid=='7080007') && is_sys_kf=='0'"
                  @click="openEditForm(scope.row)"
          >审核</el-button>
          </div>

        </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
    <edit-form
      :oneclass="oneclass"
      v-model="editFormVisible"
      @submit="getTableData"
    />

  </d2-container>
</template>
<script>
import * as oneclassService from '@/api/sys/oneclass'
import * as agentService from '@/api/sys/agent'
import editForm from './editForm'
import util from '@/libs/util.js'
export default {
  name: 'SmallposterPage',
  components: { editForm },
  data () {
    const end = new Date()
    const start = new Date()
    return {
      searchForm: {
      },
      loading: false,
      tableData: [],
      dateRange: [start, end],
      multipleSelection: [],
      is_agentid: util.cookies.get('agentid'),
      is_dl_type: util.cookies.get('dl_type'),
      is_sys_kf: util.cookies.get('is_sys_kf'),
      settleOptions: [
        {
          value: '3',
          label: '未审核'
        },
        {
          value: '0',
          label: '审核通过'
        },

        {
          value: '1',
          label: '审核未通过'
        }
      ],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: '',
        order: ''
      },
      oneclass: {},
      clicksFormVisible: false,
      exposureFormVisible: false,
      editFormVisible: false
    }
  },
  mounted () {
    this.getTableData()
  },
  methods: {
    getTableData () {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
        start_time: this.dateConversion(this.dateRange[0]),
        end_time: this.dateConversion(this.dateRange[1]),
        agentid: util.cookies.get('agentid'),
        xt_id: util.cookies.get('xt_id'),
        descending: this.sort.order === 'descending',
        filter: this.searchForm
      }
      agentService.redEnvelopesPagedList(query).then(data => {
        this.tableData = data.rows
        this.page.total = data.totalCount
      })
    },
    dateConversion (value) {
      if (value != null && value != '') {
        var d = new Date(value)
        //  var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
        var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
        console.info('===========date=========' + date)
        return date
      } else {
        return ''
      }
    },
    getImgUrl (row) {
      return 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + row.advImg
    },
    handleSearchFormSubmit () {
      this.getTableData()
    },
    handleSearchFormReset () {
      this.$refs.searchForm.resetFields()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    handleSortChange (val) {
      this.sort.prop = val.prop
      this.sort.order = val.order
      this.getTableData()
    },
    handleSizeChange (val) {
      this.page.size = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.page.current = val
      this.getTableData()
    },
    openEditForm (oneclass) {
      this.oneclass = oneclass
      this.editFormVisible = true
    },
    openExposureForm (oneclass) {
      this.oneclass = oneclass
      this.exposureFormVisible = true
    },
    openClicksForm (oneclass) {
      this.oneclass = oneclass
      this.clicksFormVisible = true
    },

    add () {
      this.oneclass = {}
      this.editFormVisible = true
    }
  }
}
</script>
